import React from 'react';
import MyPDF from '../../images/FirstResumeForSCIC-UpdateOne.pdf';

const Navbar = () => {
    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class="container-fluid">
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div class="navbar-nav">
                            <a class="nav-link active" aria-current="page" href="/">Home</a>
                            <a class="nav-link" href="/projectPage">Projects</a>
                            <a class="nav-link" href="/blogPage">Blogs</a>
                            <a class="nav-link" href="/contactPage">Contact</a>
                            <a class="nav-link"  href={MyPDF} download="FirstResumeForSCIC-UpdateOne.pdf">Download Resume</a>
                            
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;